import { useEffect } from "react";

import { CUSTOM_PLATFORM_NAME_PROP_NAME, updateSupportChatWidget } from "@/modules/support";
import { useAdminContext } from "@/providers";

import { IntercomWidget } from "../IntercomWidget/IntercomWidget";
import { getIntercomCompany } from "../intercomCompany";

/**
 * This component is intended to never be unmounted because it is
 * unfeasible to clean up the third party script that it loads.
 */
export const SupportChatWidget = () => {
  const { platform } = useAdminContext();

  useEffect(() => {
    if (platform) {
      updateSupportChatWidget({
        [CUSTOM_PLATFORM_NAME_PROP_NAME]: platform.name,
        company: getIntercomCompany(platform),
      });
    }
  }, [platform]);

  return <IntercomWidget platformId={platform?.id} company={getIntercomCompany(platform)} />;
};
